import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/quality-assurance/inspection-readiness")({
  beforeLoad: () => { throw redirect({ to: "/en/services/quality-assurance/regulatory-inspection-readiness", statusCode: 301 }); },
});
